import {NgIf} from "@angular/common";
import {Component, EventEmitter, Input, Output} from "@angular/core";
import {FormControl, ReactiveFormsModule} from "@angular/forms";

import {FormValueSyncDirective} from "../../core/directives/form-value-sync.directive";

@Component({
    selector: "app-add-new-input-field",
    standalone: true,
    imports: [NgIf, ReactiveFormsModule, FormValueSyncDirective],
    templateUrl: "./add-new-input-field.component.html",
    styleUrl: "./add-new-input-field.component.scss",
})
export class AddNewInputFieldComponent {
    @Input() buttonLabel!: string;
    @Input() inputPlaceholder!: string;
    @Input() formControlInput?: FormControl;
    @Input() maxLength?: number;
    /** Used for both id and name; browsers key their autofill heuristics off these. */
    @Input() inputId?: string;
    /**
     * Defaults to 'off' because these fields are supplementary ("Additional
     * Phone", "Additional Email") and a browser filling them with the primary
     * value is worse than leaving them empty. Callers pass a real token where
     * one applies, e.g. address-line2.
     */
    @Input() autocomplete: string = 'off';
    @Input() showErrors: boolean = false;
    @Input() errorMessages: Record<string, string> = {};
    // Once revealed (either by the Add button or by an initial value), the field
    // stays visible. We only allow flipping to true so clearing the input or an
    // autofill momentarily resetting the value doesn't hide the field again.
    @Input() set initiallyVisible(value: boolean) {
        if (value) this.showInputField = true;
    }
    @Output() inputAdded = new EventEmitter<void>();

    showInputField = false;

    handleAddButtonClick(): void {
        this.showInputField = true;
        this.inputAdded.emit();
    }

    get firstErrorMessage(): string | null {
        if (!this.formControlInput || !this.formControlInput.errors) return null;
        for (const key of Object.keys(this.formControlInput.errors)) {
            if (this.errorMessages[key]) return this.errorMessages[key];
        }
        return null;
    }

    get shouldShowError(): boolean {
        const ctrl = this.formControlInput;
        if (!ctrl || !ctrl.invalid) return false;
        return this.showErrors || ctrl.dirty || ctrl.touched;
    }
}
